import React, { memo, useState } from 'react'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { isActionValid } from '../utils/isActionValid'
import { selectInvalidAction } from '../../../store/selectors/actionsSelectors/invalidActionsSelectors'
import { selectActionParams } from '../../../store/selectors/actionsSelectors/actionsParametersSelectors'
import { postAction } from '../../../store/async-thunks/actions/postAction'
import { resetActionParameters } from '../../../store/actions/actionsActions'

interface ActionStartResetProps {
    guid: string
    actionName: string
    hasParameters: boolean
    onReset: (componentRemountKey: number) => void
}

export const ActionStartReset = memo(function ActionStartReset(
    props: ActionStartResetProps
) {
    const { guid, actionName, hasParameters, onReset } = props
    const dispatch = useAppDispatch()

    const [preventStart, setPreventStart] = useState(false)
    const actionParams = useAppSelector(selectActionParams(guid, actionName))
    const invalidAC = useAppSelector(selectInvalidAction(guid, actionName))

    const startDisabled = preventStart || !isActionValid(invalidAC ?? {})

    const handleStart = () => {
        dispatch(
            postAction({
                product_id: guid,
                action_name: actionName,
                action_params: actionParams,
            })
        )
        setPreventStart(true)
        setTimeout(() => setPreventStart(false), 3000)
    }

    const handleReset = () => {
        dispatch(resetActionParameters({ guid, actionName }))
        onReset(Math.random())
    }

    return (
        <div className="d-flex gap-2">
            <button
                disabled={!hasParameters}
                onClick={handleReset}
                className="my-3 app-btn-main app-btn-apply"
            >
                Reset
            </button>
            <button
                onClick={handleStart}
                disabled={startDisabled}
                className="my-3 app-btn-main app-btn-reset"
            >
                Start
            </button>
        </div>
    )
})
